import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import CardService from "./AnalysisService";

const initialState = {
    solutions: [],
    leads: [],
    documents_signed: null,
    documents_unsigned: null,
    solar_countracts: [],
    isSuccess: false,
    isError: false,
    isLoading: false,
    errors: [],
    start_date:  "",
    end_date: "",
};

export const GetSolutionsCount = createAsyncThunk(
    "sulutions/count",
    async (data, thunkAPI) => {
        try {
            let token = thunkAPI.getState().auth.mainUser.data.token;
            return await CardService.GetSolutionsCount(data,token);
        } catch (error) {
            let message = error.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const GetLeadsCard = createAsyncThunk(
    "leads/count",
    async (data, thunkAPI) => {
        try {
            let token = thunkAPI.getState().auth.mainUser.data.token;
            return await CardService.GetLeadsCard(data,token);
        } catch (error) {
            let message = error.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const GetEverSignDocumentSigned = createAsyncThunk(
    "document/signed",
    async (data, thunkApi) => {
        let { rejectWithValue, getState } = thunkApi;
        try {
            let token = getState().auth.mainUser.data.token;
            return await CardService.GetEverSignDocumentSigned(data,token);
        } catch (error) {
            let message = error.message;
            return rejectWithValue(message);
        }
    }
);

export const GetEverSignDocumentUnSigned = createAsyncThunk(
    "document/unsigned",
    async (data, thunkApi) => {
        let { rejectWithValue, getState } = thunkApi;
        try {
            let token = getState().auth.mainUser.data.token;
            return await CardService.GetEverSignDocumentUnSigned(data,token);
        } catch (error) {
            let message = error.message;
            return rejectWithValue(message);
        }
    }
);

const AnalysisSlice = createSlice({
    name: "cards",
    initialState,
    reducers: {
        cardsReset: (state) => {
            state.isSuccess = false;
            state.isLoading = false;
            state.isError = false;
            state.erorrs = [];
        },
        setDate: (state, action) => {
            state.start_date = action.payload.start_date;
            state.end_date = action.payload.end_date;
        }
    },
    extraReducers: {
        // Get Solution Count Analysis
        [GetSolutionsCount.pending]: (state) => {
            state.isLoaidng = true;
        },
        [GetSolutionsCount.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.solutions = action.payload;
        },
        [GetSolutionsCount.rejected]: (state) => {
            state.isLoading = false;
            state.isError = true;
        },

        // Get Leads Count Analysis
        [GetLeadsCard.pending]: (state) => {
            state.isLoaidng = true;
        },
        [GetLeadsCard.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.leads = action.payload;
        },
        [GetLeadsCard.rejected]: (state) => {
            state.isLoading = false;
            state.isError = true;
        },

        // Get Ever Sign Document Signed
        [GetEverSignDocumentSigned.pending]: (state) => {
            state.isLoaidng = true;
        },
        [GetEverSignDocumentSigned.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.documents_signed = action.payload;
        },
        [GetEverSignDocumentSigned.rejected]: (state) => {
            state.isLoading = false;
            state.isError = true;
        },

        // Get Ever Sign Document Signed
        [GetEverSignDocumentUnSigned.pending]: (state) => {
            state.isLoaidng = true;
        },
        [GetEverSignDocumentUnSigned.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.documents_unsigned = action.payload;
        },
        [GetEverSignDocumentUnSigned.rejected]: (state) => {
            state.isLoading = false;
            state.isError = true;
        },
    },
});

export const { cardsReset,setDate } = AnalysisSlice.actions;
export default AnalysisSlice.reducer;
